export default __webpack_public_path__ + "static/media/GR00051-color_spot_1.874d869d.svg";